/** * * Asynchronously loads the component for
NetworkPlan
* */ import { lazyLoad } from "utils/loadable";
export const NetworkPlan = lazyLoad(
  () => import("./index"),
  (module) => module.NetworkPlan
);
